module.exports = __webpack_public_path__ + "static/details_glass.5e58c4a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/_stories/_details/details_glass.jpg
// module id = 910
// module chunks = 85306613037350